import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5.058 4a.7.7 0 0 1 .7.7v6.596a.7.7 0 1 1-1.4 0V4.7a.7.7 0 0 1 .7-.7m6.367.197a.7.7 0 0 1 .023.99L8.766 8.002l2.682 2.815a.7.7 0 0 1-1.013.966L7.292 8.485a.7.7 0 0 1 0-.966l3.143-3.298a.7.7 0 0 1 .99-.024"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
